export * from './migration-db-seeder';

// Einzelne Migrationen (für Tests und DB-Seeding)
export * from './migration-v-1-to-v0';
export * from './migration-v0-to-v1';
export * from './migration-v1-to-v2';
export * from './migration-v2-to-v3';
export * from './migration-v3-to-v4';
export * from './migration-v4-to-v5';
export * from './migration-v5-to-v6';
export * from './migration-v6-to-v7';
